import { render, staticRenderFns } from "./KanbanFilters.vue?vue&type=template&id=50756a66&scoped=true&"
import script from "./KanbanFilters.vue?vue&type=script&lang=js&"
export * from "./KanbanFilters.vue?vue&type=script&lang=js&"
import style0 from "./KanbanFilters.vue?vue&type=style&index=0&id=50756a66&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50756a66",
  null
  
)

export default component.exports